export default __webpack_public_path__ + "static/Sketch5-3ee22e35683795d188decf648e84ce29.jpg";